import React from 'react';
import { WbCard } from '@digital-engineering-experiences/wb-webcomponents';
import s from './ListItem.module.css';
import { ListItemProps } from '../../types/components/listItem';

const ListItem = ({
    title,
    slug,
    summary,
    categories = [],
    lastPublishedAt,
}: ListItemProps) => {
    const titleItem = summary.title ? summary.title : title;
    const dateItem = lastPublishedAt
        ? new Date(lastPublishedAt).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
          })
        : '';

    return (
        <li className={s.ListItem}>
            <WbCard
                cardType="horizontal"
                cardtitle={titleItem}
                link={slug}
                date={dateItem}
                img={summary.image && summary.image?.img?.src}
                categories={categories}
                description={summary.description && summary.description}
            />
        </li>
    );
};

export default ListItem;
